import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useTotalSalesSummary = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.totalSalesSummary, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getTotalSalesSummary(), {
        params,
      });

      const composeResponse = {
        clinics: res.data.data.clinics,
        clinicTotalSales: res.data.data.clinic_total_sales_summary,
        providerTotalSales: res.data.data.provider_total_sales_summary,
      };
      return composeResponse;
    },
    options,
  );
};
